import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const QuizWrapper = ({
  children,
  ['data-test-id']: testId
}) => /*#__PURE__*/_jsx(View, {
  backgroundColor: "fill-surface-default",
  "data-test-id": testId,
  minBlockSize: "466px",
  paddingBlock: "500",
  paddingInline: "1100",
  children: children
});